import { useMutation } from "@tanstack/react-query";
import { postAdminJobsVatStatusRefresh } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

/**
 * Enqueues the VAT-register refresh job on the Worker. The request returns as soon as the job is queued;
 * the run itself is visible in the Worker log and the Hangfire dashboard, not here.
 */
export const useTriggerVatStatusRefreshMutation = () =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postAdminJobsVatStatusRefresh(),
    ),
  });
